import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";

interface TechItem {
  name: string;
  logo: string;
}

const technologies: TechItem[] = [
  { name: "Figma", logo: "https://cdn.simpleicons.org/figma/F24E1E" },
  { name: "HTML5", logo: "https://cdn.simpleicons.org/html5/E34F26" },
  { name: "CSS3", logo: "https://cdn.simpleicons.org/css3/1572B6" },
  { name: "JavaScript", logo: "https://cdn.simpleicons.org/javascript/F7DF1E" },
  { name: "WordPress", logo: "https://cdn.simpleicons.org/wordpress/21759B" },
  { name: "Bootstrap", logo: "https://cdn.simpleicons.org/bootstrap/7952B3" },
  { name: "React", logo: "https://cdn.simpleicons.org/react/61DAFB" },
  { name: "Sass", logo: "https://cdn.simpleicons.org/sass/CC6699" },
  { name: "Adobe XD", logo: "https://cdn.simpleicons.org/adobexd/FF61F6" },
];

const WdesignTechnologies: React.FC = () => {
  return (
    <section className="wdev-tech" aria-labelledby="wdesign-tech-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2 id="wdesign-tech-title" className="wdev-section-head__title">
            Design Tools &amp; Technologies
          </h2>
        </AnimatedSection>

        <div className="wdev-tech__grid">
          {technologies.map((tech, index) => (
            <motion.div
              key={tech.name}
              className="wdev-tech-card"
              initial={{ opacity: 0, scale: 0.92 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              whileHover={{ y: -4, transition: { duration: 0.2 } }}
            >
              <div className="wdev-tech-card__logo">
                <img src={tech.logo} alt={`${tech.name} logo`} loading="lazy" />
              </div>
              <span className="wdev-tech-card__name">{tech.name}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WdesignTechnologies;
